const SingleLoaderItem = ({length}) => {
    return (
            <div className="loading_mex_cont">
                {Array.from({ length: length }).map((_, index) => (
                    <div className="loading_links fade-in" key={index}></div>
                ))}
            </div>
    )
}

export default SingleLoaderItem